// Folds the deleted ConflictCard.tsx + MessageBubble's inline error/cancelled/
// timedOut text + scheduled-run badge into one status renderer, reading
// message.status (native assistant-ui discriminated union) and
// message.metadata.custom.runSource (agenthub-specific) instead of props
// threaded through the message component.

import { AlertTriangle } from 'lucide-react';
import { ErrorPrimitive, useAuiState } from '@assistant-ui/react';

export function RunStatusBadge() {
  const status = useAuiState((s) => s.message.status);
  const runSource = useAuiState((s) => (s.message.metadata?.custom as Record<string, unknown> | undefined)?.runSource);

  return (
    <div className="flex flex-col gap-1">
      {runSource === 'scheduled' && (
        <span className="w-fit rounded-full border border-border px-2 py-0.5 text-xs text-muted-foreground">
          Scheduled
        </span>
      )}
      {status?.type === 'incomplete' && status.reason === 'error' && (
        <ErrorPrimitive.Root className="flex items-center gap-1 text-xs text-destructive">
          <AlertTriangle className="size-3.5 shrink-0" />
          <ErrorPrimitive.Message />
        </ErrorPrimitive.Root>
      )}
      {status?.type === 'incomplete' && status.reason === 'cancelled' && (
        <p className="text-xs text-muted-foreground">Response stopped</p>
      )}
      {status?.type === 'incomplete' && status.reason === 'other' && (
        <div className="flex items-center gap-1 text-xs text-destructive">
          <AlertTriangle className="size-3.5" />
          <span>Request timed out</span>
        </div>
      )}
    </div>
  );
}
